var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"dialog fr-ac-jc",style:({ zIndex: _vm.zIndex })},[_c('div',{class:[`w-${_vm.width}`, 'px-30', 'py-30'],staticStyle:{"background":"#fff"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("dialogHeader"),_vm._v(" "),_vm._t("dialogMain"),_vm._v(" "),_vm._t("dialogFoot")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }